module.exports = __webpack_public_path__ + "img/02.e9ab26e0.jpg";